export var DatePickerSingleSelectionKey;
(function (DatePickerSingleSelectionKey) {
    DatePickerSingleSelectionKey["1M"] = "1M";
    DatePickerSingleSelectionKey["3M"] = "3M";
    DatePickerSingleSelectionKey["6M"] = "6M";
    DatePickerSingleSelectionKey["12M"] = "12M";
    DatePickerSingleSelectionKey["ytd"] = "ytd";
    DatePickerSingleSelectionKey["all"] = "all";
})(DatePickerSingleSelectionKey || (DatePickerSingleSelectionKey = {}));
//# sourceMappingURL=charts.models.js.map